module.exports = __webpack_public_path__ + "static/android-d6dd3a00e0bfa4b4f8166c6bf61d0e5b.jpg";